module.exports = __webpack_public_path__ + "static/media/profile.6f7263c5.png";